import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './Sidebar.module.css';

interface SidebarProps {
  isOpen?: boolean;
  onClose?: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ isOpen = true, onClose }) => {
  const menuItems = [
    { path: '/dashboard', icon: '📊', label: 'Dashboard' },
    { path: '/inventory', icon: '📋', label: 'Inventario' },
    { path: '/inventory/add', icon: '➕', label: 'Agregar Vehículo' },
    { path: '/vehicle-templates/create', icon: '📝', label: 'Crear Template' },
    { path: '/reports', icon: '📈', label: 'Reportes' },
    { path: '/settings', icon: '⚙️', label: 'Configuración' },
  ];

  const handleItemClick = () => {
    // Cerrar sidebar en móvil al hacer click en un item
    if (onClose && window.innerWidth <= 1024) {
      onClose();
    }
  };

  return (
    <aside className={`${styles.sidebar} ${isOpen ? styles.open : styles.closed}`}>
      <nav className={styles.nav}>
        <ul className={styles.menuList}>
          {menuItems.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `${styles.menuItem} ${isActive ? styles.active : ''}`
                }
                onClick={handleItemClick}
              >
                <span className={styles.icon}>{item.icon}</span>
                <span className={styles.label}>{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

